const riot = require('riot');

riot.tag2('modal-confirm', '<div class="relative w-full max-width-420 bg-white p24 rounded-8" ref="modal"> <div class="absolute t20 r24 cursor-pointer" onclick="{close}"><i class="icon-close fs20 text-label_Disabled"></i></div> <div class="bold lh15 text-label_high mb16">{opts.title}</div> <p class="lh15 white-space-pre-wrap text-label_high word-break-all mb16">{opts.message}</p> <div class="f fr"> <button class="button high f fh word-break-keep fs12 lh15 fw4 mr16" onclick="{onCancel}">{opts.negative || \'キャンセル\'}</button> <button class="button primary f fh px34 word-break-keep fs12 lh15 fw4" onclick="{onAccept}">{opts.positive || \'OK\'}</button> </div> </div>', 'modal-confirm,[data-is="modal-confirm"]{background:rgba(46,46,56,0.7)}', 'class="f fh" spat-animation="push"', function(opts) {
    this.value = false;

    this.onCancel = () => {
      this.value = false;
      this.close();
    };

    this.onAccept = () => {
      this.value = true;
      this.close();
    };
});